import React from 'react';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { useModal } from '@hooks';
import { Button, Divider, Typography } from '@ui';
import { GUIDE_IMAGE_SRC, GUIDE_TITLE, GUIDELINE_MODAL_TOP, GUIDELINE_MODAL_WRAP_CLASS } from './constants';
import GuidelineModal from './GuidelineModal';
import { GuidelineModalWrapStyle, StyledCard, StyledContent, StyledList, StyledThumbnail } from './styled';

const STEPS = [
    'Navigate to the Order Detail page in the Orders section.',
    'Click on ‘+ Block’ in the Blocks area.',
    'Add the Customer Insights Block and search for Klickly Ad Network in Key Sources.',
    'The Customer Insights block is now pinned to all your orders.',
    'Each order attributed to Klickly will feature a “Klickly” tag in the Tags section.'
];

const ShopifyCrossCheckGuide = ({ style }) => {
    const { open, close } = useModal();

    const showGuideline = () => {
        open({
            title: <span data-e2e='tracking_shopify_guide_modal_title'>{GUIDE_TITLE}</span>,
            content: <GuidelineModal close={close} />,
            addStyle: { marginBottom: '24px' },
            settings: {
                width: 1200,
                maskClosable: false,
                centered: false,
                style: { top: GUIDELINE_MODAL_TOP },
                wrapClassName: GUIDELINE_MODAL_WRAP_CLASS,
                styles: { content: { border: `2px solid ${COLORS.$gray15Black}` } }
            }
        });
    };

    return (
        <StyledCard data-e2e='tracking_shopify_guide_card' style={style}>
            <GuidelineModalWrapStyle />
            <Typography.Title level={2}>{GUIDE_TITLE}</Typography.Title>
            <Divider margin='24px 0' />
            <StyledContent>
                <Typography.Text type='body2' color={COLORS.$gray60Black} style={BOTTOM_INDENTS.S}>
                    You can enable a “Customer Insights” block to re-confirm Klickly’s attribution:
                </Typography.Text>
                <StyledList>
                    {STEPS.map((step) => (
                        <li key={step}>
                            <Typography.Text type='body2' color={COLORS.$gray60Black}>
                                {step}
                            </Typography.Text>
                        </li>
                    ))}
                </StyledList>
                <Button
                    data-e2e='tracking_shopify_guide_button'
                    backgroundColor={COLORS.$white}
                    padding='0 24px'
                    onClick={showGuideline}
                >
                    View the Guideline
                </Button>
            </StyledContent>
            <StyledThumbnail $src={GUIDE_IMAGE_SRC} aria-hidden='true' />
        </StyledCard>
    );
};

export default ShopifyCrossCheckGuide;
